export default `I am participating in a training (“Training”), provided by RescueX Training and Consulting, LLC (“RescueX”), together with additional third-party organizations that participate in trainings, of my own choice and agree to all the terms and conditions of this Waiver and Release (“Agreement”).
`
